"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _partial = _interopRequireDefault(require("transmute/partial"));

var Terms = _interopRequireWildcard(require("self-service-api/constants/Terms"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _CalculatorPriceDisplayTile = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/CalculatorPriceDisplayTile"));

var _SuiteCalcCTAsContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/growth-suite-page/SuiteCalcCTAsContainer"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _PriceBreakdownModal = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/PriceBreakdownModal"));

var _Hubs = require("self-service-api/constants/Hubs");

var _SuiteEditionMerchIdMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _SuiteCalcRequiredOnboardingSectionContainer = _interopRequireDefault(require("./SuiteCalcRequiredOnboardingSectionContainer"));

var _CovidSelectors = require("../../selectors/CovidSelectors");

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _PromotionSelectors = require("../../selectors/PromotionSelectors");

var _itemConfigUtils = require("../../utils/itemConfigUtils");

var _Calculator = require("../calculator/Calculator");

var _stateUtils = require("../../utils/stateUtils");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

// TODO should move this file to common
var SuiteCalcPriceDisplayTileContainer = function SuiteCalcPriceDisplayTileContainer(_ref) {
  var _ref2;

  var growthSuiteAvailableTerms = _ref.growthSuiteAvailableTerms;
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);

  var _useContext = (0, _react.useContext)(_Calculator.CalculatorContext),
      state = _useContext.state;

  var activeEdition = state.edition,
      marketingUnits = state.contacts,
      salesUnits = state.sales_seats,
      serviceUnits = state.service_seats,
      selectedAddOns = state.addons,
      selectedServices = state.services;

  var _useActiveTerm = (0, _stateUtils.useActiveTerm)(),
      activeTerm = _useActiveTerm.activeTerm;

  var availableTerms = growthSuiteAvailableTerms[activeEdition];
  activeTerm = (0, _itemConfigUtils.getApplicableTerm)(activeTerm, availableTerms);
  var getMultiplePriceBreakdowns = (0, _reactRedux.useSelector)(_PricingSelectors.getMultiplePriceBreakdownsSelector);
  var isCovidGrowthSuitePromoEligible = (0, _reactRedux.useSelector)(_CovidSelectors.isCovidGrowthSuitePromoEligibleSelector);
  var calculateBundlePrice = (0, _reactRedux.useSelector)(_PricingSelectors.getCalculateBundlePriceSelector);
  var currencyCode = (0, _reactRedux.useSelector)(_CurrencySelectors.activeCurrencySelector);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isModalVisible = _useState2[0],
      setModalVisibility = _useState2[1];

  var togglePriceBreakdown = function togglePriceBreakdown(isVisible) {
    setModalVisibility(isVisible);

    if (isVisible) {
      (0, _getUsageTracker.default)().track('clickToViewModal', {
        name: 'price-breakdown-modal'
      });
    }
  };

  var pricingInfoParams = {
    bundleSelections: {
      marketingPlanSelected: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[activeEdition][_Hubs.HUB_MARKETING],
      salesPlanSelected: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[activeEdition][_Hubs.HUB_SALES],
      servicePlanSelected: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[activeEdition][_Hubs.HUB_SERVICE],
      marketingUnits: marketingUnits,
      salesUnits: salesUnits,
      serviceUnits: serviceUnits,
      selectedAddOns: selectedAddOns,
      selectedServices: selectedServices
    },
    term: activeTerm,
    isGrowthSuite: true,
    isCovidPromo: isCovidGrowthSuitePromoEligible
  };
  var pricingInfo = calculateBundlePrice(pricingInfoParams);
  var allPriceBreakdowns = getMultiplePriceBreakdowns(pricingInfoParams);
  var recurringMerchPriceBreakdown = allPriceBreakdowns.filter(function (breakdown) {
    return breakdown.monthly.calculatedPrice !== 0;
  }).map(function (breakdown) {
    return {
      monthly: breakdown.monthly,
      annually: breakdown.annually
    };
  });
  var oneTimeMerchPriceBreakdown = allPriceBreakdowns.filter(function (breakdown) {
    return breakdown.oneTimeFee.calculatedPrice !== 0;
  }).map(function (breakdown) {
    return breakdown.oneTimeFee;
  });

  var getCostToGetStarted = function getCostToGetStarted() {
    var oneTimeFee = pricingInfo.oneTimeFee.calculatedPrice;

    switch (activeTerm) {
      case Terms.MONTHLY:
        return pricingInfo.monthly.calculatedPrice + oneTimeFee;

      case Terms.ANNUAL:
        return pricingInfo.annually.calculatedPrice + oneTimeFee;

      default:
        return null;
    }
  };

  var getFullCostToGetStarted = function getFullCostToGetStarted() {
    var oneTimeFee = pricingInfo.oneTimeFee.fullPrice;

    switch (activeTerm) {
      case Terms.MONTHLY:
        return pricingInfo.monthly.fullPrice + oneTimeFee;

      case Terms.ANNUAL:
        return pricingInfo.annually.fullPrice + oneTimeFee;

      default:
        return null;
    }
  }; // TODO: hacky logic for now to render cms onboarding on GS calculator.
  // Will need to return to this to determine better functionality and implemenation


  var hasCmsAddon = oneTimeMerchPriceBreakdown.filter(function (oneTimeMerch) {
    return oneTimeMerch.priceBreakdown[0].merchandiseId === _MerchandiseIds.SERVICE_CONTENT_PROFESSIONAL_ONBOARDING;
  }).length > 0;
  var billingNameKey = activeEdition === 'starter' && hasCmsAddon ? 'contentProfessional' : activeEdition;
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_CalculatorPriceDisplayTile.default, {
    gaTrackingId: 'growth',
    activeTerm: activeTerm,
    monthlyCost: pricingInfo.monthly.calculatedPrice,
    activeCurrencyCode: currencyCode,
    onViewPriceBreakdownClick: (0, _partial.default)(togglePriceBreakdown, true),
    costToGetStarted: getCostToGetStarted(),
    ctasComponent: _react.default.createElement(_SuiteCalcCTAsContainer.default, {
      edition: activeEdition,
      term: activeTerm,
      additionalUnitQuantities: (_ref2 = {}, (0, _defineProperty2.default)(_ref2, _Hubs.HUB_MARKETING, marketingUnits), (0, _defineProperty2.default)(_ref2, _Hubs.HUB_SALES, salesUnits), (0, _defineProperty2.default)(_ref2, _Hubs.HUB_SERVICE, serviceUnits), _ref2)
    }),
    requiredOnboardingSubtext: _react.default.createElement(_SuiteCalcRequiredOnboardingSectionContainer.default, {
      billingNameKey: billingNameKey,
      activeCurrency: currencyCode,
      pricingInfo: pricingInfo,
      shouldShowOnboardingSubtext: !!oneTimeMerchPriceBreakdown.length
    })
  }), isModalVisible && _react.default.createElement(_PriceBreakdownModal.default, {
    onCloseClick: (0, _partial.default)(togglePriceBreakdown, false),
    estimatedCostToGetStarted: getCostToGetStarted(),
    fullCostToGetStarted: getFullCostToGetStarted(),
    activeTerm: activeTerm,
    activeEdition: activeEdition,
    pricingInfo: pricingInfo,
    recurringMerchPriceBreakdown: recurringMerchPriceBreakdown,
    oneTimeMerchPriceBreakdown: oneTimeMerchPriceBreakdown,
    isGrowthSuite: true
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    growthSuiteAvailableTerms: (0, _PromotionSelectors.growthSuiteAvailableTermsSelector)(state, (0, _CovidSelectors.isCovidGrowthSuitePromoEligibleSelector)(state))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(SuiteCalcPriceDisplayTileContainer);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/SuiteCalcPriceDisplayTileContainer.js
// module id = 863
// module chunks = 5 6